import './ChatBox.css';

// CSS class name constants
export const InlineChatContainer = 'chat-inline-container';
export const MessagesContainer = 'messages-container';
export const UserMessageContainer = 'user-message-container';
export const UserMessageBubble = 'user-message-bubble';
export const AssistantMessageContainer = 'assistant-message-container';
export const AssistantMessageToneClarification = 'assistant-message-container--tone-clarification';
export const AssistantMessageToneAnswered = 'assistant-message-container--tone-answered';
export const AssistantMessageToneUnanswered = 'assistant-message-container--tone-unanswered';
export const AssistantHeader = 'assistant-header';
export const AssistantIcon = 'assistant-icon';
export const AssistantName = 'assistant-name';
export const AssistantMessageContent = 'assistant-message-content';
export const AssistantMessageContentError = 'assistant-message-content--error';
export const TypingIndicator = 'typing-indicator';
export const TypingDot = 'typing-dot';
export const InputContainer = 'input-container';
export const InputWrapper = 'input-wrapper';
export const TextAreaContainer = 'textarea-container';
export const TextArea = 'chat-textarea';
export const InputActions = 'input-actions';
export const SendButton = 'send-button';
export const SendButtonDisabled = 'send-button--disabled';
export const MicButton = 'mic-button';
export const MicButtonActive = 'mic-button--active';
export const InputHint = 'input-hint';
export const ChatButton = 'chat-button';
export const ChatPanel = 'chat-panel';
export const ChatHeader = 'chat-header';
export const HeaderTitle = 'header-title';
export const SiteName = 'site-name';
export const SiteLabel = 'site-label';
export const CloseButton = 'close-button';
// References styles
export const ReferencesContainer = 'references-container';
export const ReferencesTitle = 'references-title';
export const ReferencesList = 'references-list';

// Answer reasoning "Know More" bubble
export const KnowMoreContainer = 'know-more-container';
export const KnowMoreToggle = 'know-more-toggle';
export const KnowMoreToggleOpen = 'know-more-toggle--open';
export const KnowMoreIcon = 'know-more-icon';
export const KnowMoreLabel = 'know-more-label';
export const KnowMoreChevron = 'know-more-chevron';
export const KnowMoreChevronOpen = 'know-more-chevron--open';
export const KnowMoreContent = 'know-more-content';

// Quality score styles
export const QualityScoreContainer = 'quality-score-container';
export const QualityScoreShimmer = 'quality-score-shimmer';
export const QualityScoreBadge = 'quality-score-badge';
export const QualityScoreBadgeClickable = 'quality-score-badge--clickable';
export const QualityDot = 'quality-dot';
export const QualityDotGood = 'quality-dot--good';
export const QualityDotWarning = 'quality-dot--warning';
export const QualityDotPoor = 'quality-dot--poor';
export const QualityLabel = 'quality-label';
export const QualityNumeric = 'quality-numeric';
